import { createReducer, on } from '@ngrx/store';

import { FacetResult } from '../models';
import { getDrilldownFacetKey } from '../utils';

import { ArticleSearchFacetsActions, StartPageFacetsActions } from './facets.actions';

export const facetsFeatureKey = 'mpms-core-facets';

export interface FacetsState {
  facets?: FacetResult;
}

const INITIAL_STATE: FacetsState = {
  facets: undefined,
};

export const facetsReducer = createReducer(
  INITIAL_STATE,

  on(ArticleSearchFacetsActions.fetchFacets, StartPageFacetsActions.fetchFacets, (state): FacetsState => {
    return {
      ...state,
      facets: undefined,
    };
  }),

  on(
    ArticleSearchFacetsActions.fetchFacetsSuccess,
    StartPageFacetsActions.fetchFacetsSuccess,
    (state, { facets }): FacetsState => {
      return {
        ...state,
        facets,
      };
    },
  ),

  on(ArticleSearchFacetsActions.fetchDrilldownFacetSuccess, (state, { facetType, facet }): FacetsState => {
    return {
      ...state,
      facets: {
        ...(state.facets as FacetResult),
        [getDrilldownFacetKey(facetType)]: facet,
      },
    };
  }),
);
